import { render } from "./ShopProducts.vue?vue&type=template&id=6ad546a7&scoped=true"
import script from "./ShopProducts.vue?vue&type=script&lang=js"
export * from "./ShopProducts.vue?vue&type=script&lang=js"

import "./ShopProducts.vue?vue&type=style&index=0&id=6ad546a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad546a7"]])

export default __exports__